const SPINNER_STATES = [
    "load.applications.processing",
    "load.statistics.processing",
    "load.devices.processing",
    "load.projects.processing",
    "load.warehouses.processing",
];

const makeGetters = ({i18n, settings}) => ({
    currentLocale: () => i18n.locale,
    isAuthenticated: context => context.isAuthenticated,
    isLoginError: (context, state) => state.matches("authentication.guest.login.error"),
    isGuest: (context, state) => state.matches("authentication.guest.login"),
    showAppSpinner: (context, state) => SPINNER_STATES.some(state.matches),
    showApplicationsSpinner: (context, state) => state.matches("pages.applications.processing"),
    showDevicesSpinner: (context, state) => state.matches("pages.devices.processing"),
    showProjectsSpinner: (context, state) => state.matches("pages.projects.processing"),
    showWarehousesSpinner: (context, state) => state.matches("pages.warehouses.processing"),
});

export {makeGetters};
